import { CurrencyType, normalNumberToSystemCurrency, SYSTEM_DECIMALS } from '@wolffun/system-currency';
import BN from 'bn.js';
import { AppError, EipError } from 'src/redux/types';
export const calculateReceivedToken = (amountBusd, pricePerToken) => {
  const busdSystemCurrency = normalNumberToSystemCurrency(amountBusd, CurrencyType.BUSD);
  const busdBN = new BN(busdSystemCurrency.value);
  const pricePerTokenBN = new BN(pricePerToken.value);
  return busdBN.div(pricePerTokenBN);
};
export const calculateThcFee = (amountBusd, fee, exchangeRate) => {
  if (isNaN(amountBusd) || isNaN(exchangeRate) || exchangeRate <= 0 || isNaN(fee)) {
    return 0;
  }

  const busdBalance = amountBusd * fee / 100;
  return Math.ceil(busdBalance / exchangeRate * 100000) / 100000;
};
export const calculatePoolTicket = (totalSale, totalSold, busdTicket) => {
  const totalSaleBN = new BN(totalSale.value);
  const totalSoldBN = new BN(totalSold.value);
  const remainTokenBN = totalSaleBN.sub(totalSoldBN);
  const busdBN = new BN(normalNumberToSystemCurrency(busdTicket, CurrencyType.BUSD).value);
  return remainTokenBN.div(busdBN).toNumber();
};
export const calculateMaxAllocationTicket = (maxAllocation, busdTicket) => {
  const maxBN = new BN(maxAllocation.value);
  const busdBN = new BN(normalNumberToSystemCurrency(busdTicket, CurrencyType.BUSD).value);
  return maxBN.div(busdBN).toNumber();
};
export const calculateUserTicket = pTicket => {
  const pTicketBN = new BN(pTicket.value);
  const unitBN = new BN(Math.pow(10, SYSTEM_DECIMALS));
  return pTicketBN.div(unitBN).toNumber();
};
export const formatErrorMessage = error => {
  switch (error) {
    case EipError.USER_REJECTED_REQUEST:
      return 'Transaction has been canceled';

    case AppError.ALLOCATION_LIMIT_EXCEEDED:
      return 'Personal allocation limit exceeded.';

    case AppError.SALE_SOLD_OUT:
      return 'All slots are sold out. Stay tuned for upcoming projects.';

    case AppError.THC_RATE_CHANGED:
      return 'THC rate expired. Please refresh for a new rate.';

    case AppError.ALREADY_PURCHASED:
      return 'You have already purchased.';

    case AppError.INSUFFICIENT_TICKET_BALANCE:
      return 'Insufficient Private Ticket balance.';

    case AppError.INSUFFICIENT_BALANCE:
      return 'Insufficient BUSD Balance';

    case AppError.SALE_NOT_STARTED:
      return 'The Private Sale has not started yet.';

    case AppError.SALE_ENDED:
      return 'Private sale ended. Stay tuned for upcoming projects.';

    case AppError.THC_RATE_EXPIRED:
      return 'THC rate expired. Please refresh for a new rate.';

    case AppError.INVALID_PROJECT:
      return 'Invalid project. Please try again.';

    case AppError.INSUFFICIENT_THC_BALANCE:
      return 'Insufficient THC balance. Please try again.';

    case AppError.INSUFFICIENT_PRIVATE_TICKET:
      return 'You input a number higher than the available amount';

    default:
      return 'Something went wrong. Please try later.';
  }
};
export const checkUserError = ({
  amountBusd,
  amountTicket,
  busdBalance,
  maxTicket,
  thcBalance,
  thcFee,
  minTicket
}) => {
  if (amountTicket < minTicket) {
    return AppError.INSUFFICIENT_TICKET_BALANCE;
  }

  if (amountTicket > maxTicket) {
    return AppError.INSUFFICIENT_PRIVATE_TICKET;
  }

  const busdBN = busdBalance ? new BN(busdBalance.value) : undefined;
  const thcBN = thcBalance ? new BN(thcBalance.value) : undefined;
  const amountBusdBN = new BN(normalNumberToSystemCurrency(amountBusd, CurrencyType.BUSD).value);
  const thcFeeBN = new BN(normalNumberToSystemCurrency(thcFee, CurrencyType.THC).value);

  if (!busdBN || amountBusdBN.gt(busdBN)) {
    return AppError.INSUFFICIENT_BALANCE;
  }

  if (!thcBN || thcFeeBN.gt(thcBN)) {
    return AppError.INSUFFICIENT_THC_BALANCE;
  }

  return AppError.NO_ERROR;
};